import styled, { css } from 'styled-components';

import { media } from 'app/shared/styles_js/variables';

const experimentZindex = {
  cookieBanner: 1070,
  cookieBannerOverlay: 1060,
};

export const CookieBannerContainerSt = styled.div`
  position: fixed;
  z-index: ${experimentZindex.cookieBanner};
  right: 15px;
  bottom: 15px;
  left: 15px;

  ${media.md(css`
    right: auto;
    max-width: 400px;
  `)};
`;

export const CookieBannerContentSt = styled.div`
  display: flex;
  padding: 15px;
  border-radius: 4px;
  font-size: 13px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  background-color: ${({ theme: { colors } }) => colors.grayLightest};
`;

export const CookieBannerTextWrapperSt = styled.div`
  flex-grow: 1;
  font-size: 10px;
  line-height: 1.6;
  letter-spacing: 0.03em;
  padding-bottom: 75px;

  .fonts-loaded &,
  .fonts-observer-fail & {
    letter-spacing: 0;
  }

  p {
    margin: 0;
  }
`;

export const CookieBannerCallToActionSt = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  place-items: center;
  gap: 15px;
  height: 60px;
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;

  a {
    letter-spacing: 0.02em;
    line-height: 1.43;

    .fonts-loaded &,
    .fonts-observer-fail & {
      letter-spacing: 0;
      line-height: normal;
    }
  }

  a,
  button {
    text-align: center;
    font-weight: bold;
    height: fit-content;
  }
`;

export const CookieBannerOverlaySt = styled.div`
  position: fixed;
  z-index: ${experimentZindex.cookieBannerOverlay};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.8;
  background-color: ${({ theme: { colors } }) => colors.black};
`;
